import { Button } from "@/shadcn/components/ui/button";
import { Textarea } from "@/shadcn/components/ui/textarea";
import { ChatMessage } from "@/types";
import React, { useState } from "react";

type ChatFooterProps = {
  sendMessage: (message: string) => Promise<boolean>;
  isSending: boolean;
  messages: ChatMessage[];
};

const ChatFooter: React.FC<ChatFooterProps> = ({
  sendMessage,
  isSending,
  messages,
}) => {
  const [message, setMessage] = useState<string>("");

  async function handleSendMessage() {
    console.log("Sending message:", message);
    if (message.trim() === "") {
      return;
    }
    const success = await sendMessage(message);
    if (success) {
      setMessage("");
    }
  }

  function getPreviousUserMessage() {
    // Check if the message is empty
    if (message) {
      return;
    }

    // Check if the user is currently sending a message
    if (isSending) {
      return;
    }

    // Check if there are any messages in the chat history
    if (messages.length === 0) {
      return;
    }

    // Find the last user message in the chat history and set it as the current message
    const userMessages = messages.filter((msg) => msg.sender === "user");
    const lastUserMessage = userMessages[userMessages.length - 1];
    if (lastUserMessage) {
      setMessage(lastUserMessage.message);
    }
  }

  return (
    <div className="flex items-center justify-center w-full px-2 py-2 max-h-[30%]">
      <Textarea
        id="chat-message"
        className="flex-grow py-0 border border-gray-300 rounded-md my-2 !min-h-11 h-auto max-h-full"
        placeholder="Type a message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSendMessage();
          }
          if (e.key === "ArrowUp") {
            getPreviousUserMessage();
          }
        }}
        disabled={isSending}
        maxLength={255}
      />
      <Button
        className="ml-4 btn btn-primary rounded-md"
        onClick={handleSendMessage}
        disabled={isSending}
      >
        Send
      </Button>
    </div>
  );
};

export default ChatFooter;
